"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyInfo = exports.postLogin = void 0;
var core_1 = __importDefault(require("@/api/core"));
var postLogin = function (_a) {
    var username = _a.username, password = _a.password;
    return core_1.default.post({
        url: '/admin-members/login',
        data: {
            username: username,
            password: password,
        },
    });
};
exports.postLogin = postLogin;
var getMyInfo = function () {
    return core_1.default.get({
        url: '/admin-members/me',
    });
};
exports.getMyInfo = getMyInfo;
